import React from 'react';
import './Button.scss';

type IButton = {
  title: string;
  disabled?: boolean;
  onClick?: any;
  className?: string;
  type?: "button" | "submit" | "reset" | undefined;
}

const Button = ({ className, title, disabled, onClick, type = "button" }: IButton) => {
  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={`${className} button-wrapper ${disabled && 'disabled-button'}`}
    >
      {title}
    </button>
  )
}

export default Button;
